import { useState, useEffect } from "react";

function AddToCartButton({
  loading,
  Skeleton,
  handleAddToCart,
  quantity,
  toggleWishlist,
  selectedSize,
  Heart,
}) {
  const [isWishlisted, setIsWishlisted] = useState(false);

  // Sync local state when selectedSize changes
  useEffect(() => {
    setIsWishlisted(selectedSize?.is_wishlisted === 1);
  }, [selectedSize]);

  const handleWishlistClick = (e) => {
    e.stopPropagation();

    // Toggle UI instantly
    setIsWishlisted((prev) => !prev);

    // Call parent wishlist logic
    toggleWishlist(e, selectedSize);
  };
  return (
    <div className="add-cart-sticky-wrapper">
      <div className="add-cart-section">
        {loading ? (
          <Skeleton
            height={45}
            width={180}
            borderRadius={8}
            style={{ marginRight: 20 }}
          />
        ) : (
          <>
            <button
              type="button"
              className="add-to-cart-btn_qucick"
              onClick={handleAddToCart}
              disabled={quantity === 0 || selectedSize?.stock <= 0}
            >
              {selectedSize?.stock <= 0 || quantity === 0
                ? "Out of Stock"
                : "ADD TO CART"}
            </button>

            <div
              className="wst_box_quick pointer-crusser"
              onClick={handleWishlistClick}
            >
              {isWishlisted ? (
                <Heart
                  size={27}
                  color="#FF0000"
                  fill="#FF0000"
                />
              ) : (
                <Heart
                  size={27}
                  color="#000"
                  fill="none"
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default AddToCartButton;